import React from 'react';

function OpenSourceBox({topics}) {
  return (
    <div 
      className="relative flex flex-col justify-center items-center w-full h-[300px] font-custom"
      style={{ backdropFilter: 'blur(7px) brightness(80%)' }}
    >
      <div className="absolute bg-white opacity-20"></div>
      
      <div className="relative z-10 flex flex-col items-center justify-center text-center p-4 h-full">
        <ul className="list-none p-0 m-0">
          {topics.map((topic, index) => (
            <li key={index} className="text-gray-100 text-xl md:text-2xl font-medium opacity-60 hover:opacity-100 font-light">
              <a href={topic.link} download>
                {topic.topic}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default OpenSourceBox;